/* eslint dom-in-jsx/no-document-calls: 0 */

import React, { Component } from 'react';
import { render } from 'react-dom';
import moment from 'moment-timezone';

class History extends Component {
  constructor(props) {
    super(props);
    this.state = { logs: window.payment_device_logs };
  }

  componentDidMount() {
    Messenger.on(
      `/pinpad_retrieve_${this.props.device}`,
      this.handleUpdate.bind(this),
    );
  }

  handleUpdate(data) {
    this.setState({ logs: this.mergeLogs(this.state.logs, data.logs) });
  }

  mergeLogs(firstList, secondList) {
    let result = [...firstList];

    secondList.forEach(function (el) {
      let idx = result.findIndex((item) => item.id === el.id);

      if (idx === -1) {
        result.unshift(el);
      } else {
        result[idx] = el;
      }
    });
    return result;
  }

  formatDate(date) {
    if (!date) {
      return false;
    }
    return moment(date)
      .tz(moment.tz.guess())
      .format('dddd, MMMM Do YYYY, h:mm:ss a z');
  }

  formatStatus(item) {
    return item.status
      ? item.status.charAt(0).toUpperCase() + item.status.slice(1)
      : 'Running';
  }

  changedColumn(i, method) {
    return Object.keys(i.updates).map((objkey) => {
      let value = _[method](i.updates[objkey]);

      return (
        <p
          key={objkey}
          className={method}
        >
          <strong>{objkey}:</strong> {_.isEmpty(value) ? 'None' : value}
        </p>
      );
    });
  }

  anyChanges(updates) {
    if (_.isEmpty(updates)) {
      return false;
    }
    return _.every(
      Object.keys(updates),
      (objKey) =>
        !_.isEmpty(_.first(updates[objKey])) ||
        !_.isEmpty(_.last(updates[objKey])),
    );
  }

  render() {
    return (
      <table className='ui striped table'>
        <thead>
          <tr>
            <th>Job Started</th>
            <th>Job Finished</th>
            <th>Status</th>
            <th>Data Before</th>
            <th>Data After</th>
          </tr>
        </thead>
        <tbody>
          {this.state.logs.map((i) => {
            return (
              <tr key={i.id}>
                <td>{this.formatDate(i.started_at)}</td>
                <td>{this.formatDate(i.finished_at) || 'None'}</td>
                <td>{this.formatStatus(i)}</td>
                <If condition={!this.anyChanges(i.updates)}>
                  <td
                    className='none'
                    colSpan='2'
                  >
                    <Choose>
                      <When condition={_.isEmpty(i.message)}>
                        <p>
                          {_.isEmpty(i.status)
                            ? 'No changes yet'
                            : 'No changes were made'}
                        </p>
                      </When>
                      <Otherwise>
                        <p>{i.message}</p>
                      </Otherwise>
                    </Choose>
                    <If
                      condition={
                        typeof i.received_data.formattedmsg !== 'undefined'
                      }
                    >
                      <p className={i.status}>{i.received_data.formattedmsg}</p>
                    </If>
                    <If
                      condition={typeof i.received_data.error !== 'undefined'}
                    >
                      <p className={i.status}>{i.received_data.error}</p>
                    </If>
                  </td>
                </If>
                <If condition={!_.isEmpty(i.updates)}>
                  <td
                    className='none'
                    colSpan='2'
                  >
                    <div className='device-changes'>
                      <div className='before'>
                        {this.changedColumn(i, 'first')}
                      </div>
                      <div className='after'>
                        {this.changedColumn(i, 'last')}
                      </div>
                      <div className='serial-error-info'>
                        <If
                          condition={
                            typeof i.received_data.formattedmsg !== 'undefined'
                          }
                        >
                          <p className={i.status}>
                            {i.received_data.formattedmsg}
                          </p>
                        </If>
                        <If
                          condition={
                            typeof i.received_data.error !== 'undefined'
                          }
                        >
                          <p className={i.status}>{i.received_data.error}</p>
                        </If>
                      </div>
                    </div>
                  </td>
                </If>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

module.exports = function (params) {
  render(
    <History device={params.id} />,
    document.querySelector('#history-container'),
  );
  this.destroy = () => {
    Messenger.unsubscribe(`/pinpad_retrieve_${params.id}`);
  };
};
